import * as React from 'react';
import { DataSignal } from 's-js';
import SuperCritical from 'lib/supercritical';

import { DefaultReminders } from 'data/models/ConfigureReminders';

import { ConfigureReminders } from './model';
import { NullableNumericInput } from 'portcall/numericinput/view';
import { OrgHeaderView } from 'portcall/orgprofile/orgheaderview';
import { ValidationWatcher } from 'lib/validationWatcher';
import { ValidationErrorView } from 'core/validationerror/view';

export const ConfigureRemindersView = SuperCritical(({ model: m } : { model : ConfigureReminders }) =>
    <div className="configurereminders pc-page-fixedwidth">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href={'#!orgprofile?id=' + m.Organization.Id() }>&lt;&lt; Back to Organization</a>
        </div>
        <OrgHeaderView organization={m.Organization} />
        <div className="main-page pc-card">
            <div>
                <div className="pc-card-title">Configure Reminders</div>
            </div>
            <div className="reminders">
                <ReminderView reminder={m.FirstReminderWindow}
                    reminderName="First"
                    validation={m.Validation}
                    validationKey="FirstReminderWindow"
                    reminderDirty={m.FirstReminderDirty}
                    defaultReminderWindow={m.Model.DefaultReminders.DefaultFirstReminderWindow} />
                <ReminderView reminder={m.FinalReminderWindow}
                    reminderName="Final"
                    validation={m.Validation}
                    validationKey="FinalReminderWindow"
                    reminderDirty={m.FinalReminderDirty}
                    defaultReminderWindow={m.Model.DefaultReminders.DefaultFinalReminderWindow} />
            </div>
        </div>
    </div>
);

let ReminderView = SuperCritical(({ reminder, reminderName, validation, validationKey, reminderDirty, defaultReminderWindow } : {
    reminder : DataSignal<number | null>,
    reminderName : string,
    validation : ValidationWatcher,
    validationKey : string,
    reminderDirty : DataSignal<boolean>,
    defaultReminderWindow : () => number
}) =>
    <div>
        <div className="reminder-configuration">
            <span className="reminder-type">{reminderName} Reminder</span>
            <span className="reminder-verb">goes out</span>
            <NullableNumericInput className="reminder-value"
                value={reminder}
                onBlur={() => reminderDirty(false)} />
            <span className="reminder-short-descr">days before the Port Call's First Line.</span>
            <div className="reminder-long-descr">
                Specify when the {reminderName} Reminder gets emailed. By default, the email is sent
                {' '}
                {defaultReminderWindow()}
                {' '}
                days before the First Line Date.
            </div>
        </div>
        <ValidationErrorView error={() => validation()[validationKey]} />
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/configurereminders/view.tsx